var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas"}),(!_vm.datasets || !_vm.datasets.length)?_c('LoadingSpinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }